const managerFinishFlow = () => {
	return `mutation ManagerFlowComplete(
		$appraisee_id: String!
		$flowType: String!
		$pendency: String
		$year: Int
	) {
		managerFlowComplete(
			appraisee_id: $appraisee_id
			flowType: $flowType
			pendency: $pendency
			year: $year
		)
	}`;
}

export default managerFinishFlow;
